import { HttpResponse } from '@angular/common/http';

// Function to download file from blob when returned from API.
// Make sure in http request options: `responseType` is 'blob' and `observe` is 'response'
export function downloadBlob(fileName?: string): (response: HttpResponse<Blob>) => void {
  return (response: HttpResponse<Blob>) => {
    if (!fileName) {
      try {
        const contentDisposition = response.headers.get('content-disposition');
        fileName = contentDisposition.split('=')[1].trim().replace(/"/g, '');
      } catch {
        console.warn('content-disposition header is not exposed by the server.');
      }
    }
    const blob = new Blob([response.body], {
        type: response.body.type,
      }),
      objectUrl = (window.URL || window.webkitURL).createObjectURL(blob),
      link = document.createElement('a');

    link.href = objectUrl;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
}
